import { Spinner } from '@concord/ui';
import { useIsFetching } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

/** Wait this long before showing it, so a quick load never flickers. */
const DELAY_MS = 250;

/**
 * "Loading…" in the middle of the screen while it waits for data it does not have yet: a
 * first visit, a new page, a new filter. Background refreshes of data already on screen
 * stay quiet, and so do saves (their buttons show their own progress).
 */
export function PageLoading() {
  const waiting = useIsFetching({ predicate: (q) => q.state.data === undefined }) > 0;
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!waiting) {
      setShow(false);
      return;
    }
    const t = setTimeout(() => setShow(true), DELAY_MS);
    return () => clearTimeout(t);
  }, [waiting]);
  if (!show) return null;
  return (
    <div className="page-loading">
      <Spinner />
    </div>
  );
}
